import { userConstants } from '../_constants';
import { userService } from '../_services';
import { alertActions } from '.';
import { history } from '../_helpers';
import { createProfileAction } from './UserProfile/createProfile.action';
import { cookieUtils } from '../_helpers/cookieUtils';

export const userActions = {
    login,
    logout,
    getAll,
};

function login(data) {


    return dispatch => {
        dispatch(request({ data }));

        userService.login(data)
            .then(
                user => {
                    dispatch(success(user));

                    dispatch(createProfileAction.isSignUpCompleted(localStorage.getItem('is_sign_up_completed')))

                    const userType = localStorage.getItem('usertype');
                    const isAuthParticipant = localStorage.getItem("is_auth_participant");
                    const assessmentCompleted = localStorage.getItem('assessment_completed');

                    const isAdmin = userType.includes('super_admin') || userType.includes('seller_admin') || userType.includes('organisation_admin')


                    if (userType.includes('participant') && !isAdmin || userType.length === 0) {
                        const id = localStorage.getItem('assessment_id');
                        const seller = localStorage.getItem('seller');
                        const organisation = localStorage.getItem('organisation');
                        const participant__id = localStorage.getItem('participant__id');
                        const instrument__is_multi_rater = localStorage.getItem('instrument__is_multi_rater');
                        const assessment_completed_count = localStorage.getItem('assessment_completed_count');
                        if (isAuthParticipant === 'true') {
                            if (assessmentCompleted === 'true') {
                                history.push('/assessment-expired');
                            } else {
                                history.push(`/new/app/questionnaire/9/${id}/${organisation}/${seller}/${participant__id}/${instrument__is_multi_rater}/${assessment_completed_count}/assessment`);
                            }
                        } else {

                            const lastAttemptedRoute = cookieUtils.getCookie('lastAttemptedRoute');
                            if (lastAttemptedRoute) {
                                cookieUtils.deleteCookie('lastAttemptedRoute'); // Clear immediately before navigation
                                history.push(lastAttemptedRoute);
                            } else {
                                history.push(`/new/app/dashboard`);
                            }
                        

                        }
                    } else {
                        history.push('/admin/app/dashboard', { disableBackButton: true });
                    }
                },
                error => {
                    dispatch(failure(error));
                    dispatch(alertActions.error(error));
                }
            );
    };

    function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
    function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
    userService.logout();
    // cookieUtils.deleteCookie('lastAttemptedRoute');
    return { type: userConstants.LOGOUT };
}

function getAll() {
    return dispatch => {
        dispatch(request());

        userService.getAll()
            .then(
                users => dispatch(success(users)),
                error => dispatch(failure(error))
            );
    };

    function request() { return { type: userConstants.GETALL_REQUEST } }
    function success(users) { return { type: userConstants.GETALL_SUCCESS, users } }
    function failure(error) { return { type: userConstants.GETALL_FAILURE, error } }
}




// WEBPACK FOOTER //
// ./src/_actions/user.actions.js